import { useTheme, css } from '@vebox/etui-system';
import '../../utilities/format-ms.js';
import '../../utilities/create-transition.js';
import { createElement } from 'react';
import '../../utilities/get-styleprop.js';
import { _ as _objectWithoutProperties, b as _extends, a as _objectSpread2 } from '../../_rollupPluginBabelHelpers-3b7bd988.js';
import '@vebox/etui-system-elements';
import '../../Svg-0180d7b5.js';
import '../../Icon/Icon.js';
import '@vebox/etui-icons';
import '../../Icon/icons.js';
import '../../Icon/helper.js';
import '@vebox/etui-colors';
import '../../ClickOutside/ClickOutside.js';
import '../../Tooltip/Tooltip.js';
import Button from '../../Button/Button.js';
import { colors } from '../colors.js';
import { HEADER_HEIGHT } from './constants.js';

const _excluded = ["styles"];
const HeaderButton = _ref => {
  let {
      styles = {}
    } = _ref,
    rest = _objectWithoutProperties(_ref, _excluded);
  const theme = useTheme();
  return /*#__PURE__*/createElement(Button, _extends({
    getHoverStyles: () => css`
          background-color: ${colors.itemHover};
        `,
    getActiveStyles: () => css`
          background-color: ${colors.background};
        `,
    styles: _objectSpread2(_objectSpread2({}, styles), {}, {
      root: _objectSpread2({
        height: `${HEADER_HEIGHT}px`,
        width: `${HEADER_HEIGHT}px`,
        color: `${theme.palette.common.white} !important`,
        borderRight: `1px solid ${theme.palette.black[80]} !important`
      }, styles.root)
    })
  }, rest));
};

export default HeaderButton;
